<template>
  <div class="pay-vip-pipup">
    <el-dialog
      class="pay-vip-div"
      width="1080px"
      top="120px"
      :visible.sync="innerVisible"
      @close="closeGoodsPay"
      :modal-append-to-body="false"
    >
      <div class="pay-vip-head">
        <!-- <div
          @click="changeGoodsType(0)"
          :class="{ 'goods-type': true, 'goods-type-active':  === 0 }"
        >
          <p>购买会员检测</p>
        </div> -->
        <div
          @click="changeGoodsType(1)"
          :class="{ 'goods-type': true, 'goods-type-active': goodsType === 1 }"
        >
          <p>购买积分检测</p>
          <span>剩余积分：{{ userInfo.remain_integral }}</span>
        </div>
      </div>
      <div class="pay-vip-body">
        <div
          @click="choosePayGoods(idx)"
          v-for="(goods, idx) in payGoodsList"
          :class="{
            'pay-vip-item': true,
            'pay-vip-item-active': payGoodsId === idx
          }"
        >
          <div class="item-top">
            <p>{{ goods.price }}<span>元</span></p>

            <h1 v-if="goods.integral">{{ goods.integral }}积分</h1>

            <del v-show="goods.original_price">
              {{ goods.original_price }}<span>元</span>
            </del>
            <div></div>
          </div>

          <div class="item-bottom">
            <p v-if="goods.is_submit_paper">{{ goods.title }}</p>
            <p v-else-if="goodsType === 0">
              {{ goods.title }}：{{ goods.day_check_limit }}
            </p>
            <p v-else-if="goodsType === 1">{{ goods.day_check_limit }}</p>
          </div>

          <div
            :class="
              payGoodsId === idx
                ? 'triangle-topright tt-active'
                : 'triangle-topright'
            "
          >
            <img src="/static/img/icon_choose.svg" alt="" srcset="" />
          </div>
        </div>
        <div class="pay-vip-methods">
          <div
            class="left-pays"
            v-if="!(payGoodsId == 0 && checkCardId && buyType == '2')"
          >
            <div
              :class="{
                'pay-method': true,
                'pay-method-active-wx': payType == 'wxpay'
              }"
              @click="setPaymentQrcode('wxpay')"
            >
              <img :src="wxIconPath" alt="" />
              <span>微信</span>
            </div>
            <div
              :class="{
                'pay-method': true,
                'pay-method-active-zfb': payType == 'alipay'
              }"
              @click="setPaymentQrcode('alipay')"
            >
              <img :src="zfbIconPath" alt="" />
              <span>支付宝</span>
            </div>
          </div>
          <div class="right-qrcode">
            <div class="qrcode-box">
              <p v-show="hasQrcodeErr" :title="payQrcodeErr" class="payerror">
                {{ payQrcodeErr }}
              </p>
              <div
                v-show="!hasQrcodeErr"
                ref="qrCodeDiv"
                id="qrCodeDiv"
                alt="支付二维码"
              ></div>
            </div>
            <p>
              <span>¥{{ payMoney }}</span>
            </p>
            <p></p>
            <div v-if="goodsType == 1">
              <p>1积分可当做1元检测使用</p></p>
              <p v-if="payGoodsId == 0 && buyType == '2'">本次检测将消费{{ payMoney }}积分</p>
              <p v-else></p>
            </div>
            <div v-else>
              <p v-if="payType == 'alipay'">支付宝扫码支付</p>
              <p v-else-if="payType == 'wxpay'">微信扫码支付</p>
            </div>
            <!-- <p>支付即表示您同意我们的<span>《服务协议》</span></p> -->
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 支付成功 begin -->
    <el-dialog
      class="pay_succ"
      :lock-scroll="false"
      title=""
      :visible="showMsgBox"
      @close="showMsgBox = false"
      top="20vh"
      width="420px"
      height="40vh"
      :modal-append-to-body="false"
    >
      <div class="pay_succ_box">
        <img src="/static/img/icon_pay_succ.png" alt="" class="" />
        <span>{{ msgBoxTitle }}</span>
        <p v-if="msgBoxContent">{{ msgBoxContent }}</p>
        <el-button type="primary" @click="notifySubmit()">立即检测</el-button>
      </div>
    </el-dialog>
    <!-- 支付成功 end -->
  </div>
</template>

<script>
import {
  // vip积分购买
  get_integral_goods_list,
  _user_get_pay_url,
  _user_get_vip_goods_list,
  _user_get_pay_result,
  _user_get_info,
  _get_gz_user_coupon,
  // 轮询支付结果
  get_pay_result
} from "../../api/index";
import QRCode from "qrcodejs2";

export default {
  name: "pay-vip-popup",
  data() {
    return {
      isPayVip: false,
      payGoodsList: [],
      payGoodsId: 0,
      payType: "wxpay",
      payMoney: 0.0,
      userInfo: {},
      paysInfo: {},
      payQrcodeUrl: "",
      payTid: "",
      payTidExpireTime: 0,
      payQrcodeErr: "",
      hasQrcodeErr: false,
      checkPayResTimer: null,
      showMsgBox: false,
      msgBoxTitle: "",
      msgBoxContent: "",
      qrcodeLifeTimer: null,
      checkCardId: "",
      goodsType: 1, // 0 vip 1 积分,
      goodsPostData: {}, // 请求充值商品的参数
      wxIconPath: '/static/img/wx_hover.png',
      zfbIconPath: '/static/img/zfb.png',
      buyType: 1, //1-vip 2-单篇 3-积分
    };
  },
  props: {
    isShowPayVip: {
      default: false
    },
    checkType: {
      type: String
    },
    wordNum: {
      type: Number,
      default: 0
    },
    isSubPaper: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    choosePayGoods(goodsId = 0) {
      this.payGoodsId = goodsId;
      clearTimeout(this.checkPayResTimer);
      this.payQrcodeErr = "加载中...";

      // 选择充值类型（vip，积分商品，积分单篇）
      let goodsObj = this.payGoodsList[goodsId];
      if (this.goodsType==1 && goodsObj.is_submit_paper && this.wordNum>0 && this.checkType) {
        this.buyType = 2; // 积分单篇购买
      } else if (this.goodsType == 1 && !goodsObj.is_submit_paper) {
        this.buyType = 3; // 积分商品购买
      } else if (this.goodsType == 0) {
        this.buyType = 1; // vip 购买
      } else {
        this.$message.error("请选择正确的充值类型");
        return false;
      }
      this.payMoney = goodsObj.price;
      this.getPayQrcode();
    },
    setPaymentQrcode(paytype) {
      this.payType = paytype;
      if(paytype == 'wxpay') {
        this.wxIconPath = '/static/img/wx_hover.png';
        this.zfbIconPath = '/static/img/zfb.png';
      }else{
        this.wxIconPath = '/static/img/wx.png';
        this.zfbIconPath = '/static/img/zfb_hover.png';
      }
      this.payQrcodeErr = "加载中...";
      clearTimeout(this.checkPayResTimer);
      clearTimeout(this.qrcodeLifeTimer);
      if (!this.paysInfo[paytype]) {
        this.getPayQrcode();
        return;
      }
      this.hasQrcodeErr = false;
      this.payQrcodeUrl = this.paysInfo[paytype].qrcode_url;
      this.payTid = this.paysInfo[paytype].tid;
      this.payTidExpireTime = this.paysInfo[paytype].time_expire;
      this.makePayQrcode();
      this.getPayResult();
    },
    changeGoodsType(goodsType = 1) {
      this.goodsType = goodsType;
      this.getPayGoodsList(this.goodsPostData);
    },
    getPayGoodsList(postdata = {}) {
      if (this.goodsType === 0) {
        this.getVipGoodsList(postdata);
      } else if (this.goodsType === 1) {
        this.getIntergralGoodsList(postdata);
      }
    },
    getVipGoodsList(postdata = {}) {
      _user_get_vip_goods_list(postdata)
        .then(res => {
          this.payGoodsList = res.slice(0, 5);
          this.choosePayGoods(0);
        })
        .catch(err => {
          this.$message.error(err.info);
        });
    },
    getIntergralGoodsList(postdata = {}) {
      get_integral_goods_list(postdata)
        .then(res => {
          this.payGoodsList = res.slice(0, 5);
          this.choosePayGoods(0);
        })
        .catch(err => {
          this.$message.error(err.info);
        });
    },
    getPayQrcode() {
      this.getGoodsPayUrl(this.buyType);
    },
    getGoodsPayUrl(buyType) {
      let postdata = {};
      postdata.buy_type = buyType;
      if(buyType == 1) { // 会员支付
        postdata.goods_id = this.payGoodsList[this.payGoodsId].id;
      } else if (buyType == 2) { // 单篇支付
        postdata.wordnum = this.wordNum;
        postdata.chktype = this.checkType;
      } else if (buyType == 3) { // 积分支付
        postdata.goods_id = this.payGoodsList[this.payGoodsId].id;
      } else {
        this.renderPayTpl("请选择正确的方式进行充值");
        return false;
      }

      _user_get_pay_url(postdata).then(res=>{
        this.paysInfo = res;
        if (!this.paysInfo[this.payType]) {
          throw { info: "支付方式不存在！" };
        }
        this.hasQrcodeErr = false;
        this.payQrcodeUrl = this.paysInfo[this.payType].qrcode_url;
        this.payTid = this.paysInfo[this.payType].tid;
        this.payTidExpireTime = this.paysInfo[this.payType].time_expire;
        this.makePayQrcode();
        this.getPayResult();
      }).catch(err => {
        this.renderPayTpl(err.info);
      });
    },
    /**
     * 将支付链接转换为二维码
     */
    makePayQrcode() {
      var that = this;
      clearTimeout(this.qrcodeLifeTimer);
      this.qrcodeLifeTimer = setTimeout(() => {
        that.renderPayTpl("二维码已过期");
        window.clearTimeout(that.checkPayResTimer);
      }, this.payTidExpireTime * 1000);

      let payUrl = this.payQrcodeUrl;
      if (!payUrl) {
        this.$message.error("支付链接不正确");
        return false;
      }
      this.$refs.qrCodeDiv.innerHTML = "";
      new QRCode(this.$refs.qrCodeDiv, {
        text: payUrl,
        width: 148,
        height: 148,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    getPayResult() {
      var that = this;
      get_pay_result({ tid: this.payTid })
        .then(res => {
          clearTimeout(that.checkPayResTimer);

          let message = this.goodsType == 1 ? "积分充值成功" : "会员购买成功";
          if (res == "SUCCESS") {
            this.showMessageBox("支付成功", message);
            this.showMsgBox = true;
            this.isShowPayVip = false;
            this.renderPayTpl("支付成功");
            this.paysInfo = {};
          } else {
            that.checkPayResTimer = setTimeout(function() {
              that.getPayResult();
            }, 3 * 1000);
          }
        })
        .catch(err => {
          this.renderPayTpl(err.info);
        });
    },
    renderPayTpl(errMsg) {
      if (this.checkPayResTimer) clearTimeout(this.checkPayResTimer);
      if (this.qrcodeLifeTimer) clearTimeout(this.qrcodeLifeTimer);
      this.hasQrcodeErr = true;
      this.payQrcodeUrl = "";
      this.payTidExpireTime = 0;
      this.payQrcodeErr = errMsg;
    },
    closeGoodsPay() {
      clearTimeout(this.checkPayResTimer);
      clearTimeout(this.qrcodeLifeTimer);
      this.innerVisible = false;
    },
    showMessageBox(title, content) {
      this.showMsgBox = true;
      this.msgBoxTitle = title;
      this.msgBoxContent = content;
    },
    notifySubmit() {
      this.$emit("submitUserPaper");
      this.showMsgBox = false;
      this.closeGoodsPay();
    },
    initPayList(postdata) {
      if(this.isSubPaper) this.buyType = 2;
      this.goodsPostData = postdata;
      this.getPayGoodsList(postdata);
      this.getUserInfo();
    },
    getUserInfo() {
      _user_get_info().then(res => {
        this.userInfo = res;
      });
    }
  },
  created() {},
  computed: {
    innerVisible: {
      get: function() {
        return this.isShowPayVip;
      },
      set: function(val) {
        this.$emit("update:isShowPayVip", val);
      }
    }
  }
};
</script>

<style scoped>
/* 弹窗头部样式 */
.pay-vip-div /deep/ .el-dialog__header {
  height: 80px;
  background: #e2f7eb;
}

.pay-vip-head {
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 110px;
  /* margin-top: 20px;
  margin-left: 40px; */
}

.pay-vip-head img {
  float: left;
  width: 70px;
  height: 70px;
  border: 1px solid #666666;
  border-radius: 50%;
  margin-right: 18px;
}

.pay-vip-head > p:nth-child(2) {
  float: left;
  width: 200px;
  text-align: left;
  font-size: 20px;
  margin-top: 5px;
  color: #000000;
}

.pay-vip-head > p:nth-child(3) {
  float: left;
  width: 200px;
  text-align: left;
  font-size: 14px;
  color: #8d8e8f;
  margin-top: 10px;
}

.pay-vip-head > p:nth-child(2) span {
  font-size: 18px;
  color: #fb2e0d;
}

/* 弹窗主体样式 */
.pay-vip-div /deep/ .el-dialog__body {
  height: 385px;
}

.pay-vip-body {
  width: 100%;
  height: 347px;
  margin: 10px auto;
}

/* 积分购买 */
.pay-vip-item {
  float: left;
  width: 185px;
  height: 117px;
  margin: 0 10px;
  background: #ffffff;
  cursor: pointer;
  border: 1px solid #efefef;
}

.pay-vip-item-active {
  border: 1px solid #ff7900;
}

.float-last {
  margin-right: 0px;
}

.pay-vip-methods {
  float: left;
  width: 97%;
  height: 196px;
  background: #ffffff;
  border: 1px solid #d6d8da;
  margin-top: 34px;
  margin: 34px 10px 0 10px;
}

.triangle-topright {
  float: right;
  margin-top: 25px;
  width: 0;
  height: 0;
  border-top: 38px solid #ffffff;
  border-left: 45px solid transparent;
}

.tt-active {
  position: relative;
  float: right;
  bottom: 121px;
  width: 0;
  height: 0;
  border-top: 38px solid #ff7900;
  border-left: 45px solid transparent;
}

.triangle-topright img {
  right: 20px;
  position: relative;
  bottom: 35px;
}

.item-top p {
  float: left;
  font-size: 30px;
  font-weight: 600;
  color: #ff7900;
  margin-left: 10px;
  margin-top: 15px;
}
.item-top h1 {
  position: relative;
  font-size: 22px;
  font-weight: bold;
  float: left;
  margin-left: 2px;
  top: 25px;
  text-align: right;
}
.item-top span {
  font-size: 12px;
  color: #333333;
}

.item-top > del {
  margin-top: 32px;
  float: left;
  margin-left: 10px;
}

.item-top > del > span {
  font-size: 12px;
  color: #333333;
}

.item-top div {
  bottom: 549px;
  margin: 0 9px;
  width: 165px;
  border-bottom: 1px solid #ebebeb;
  margin-top: 70px;
}

.item-bottom {
  float: left;
  width: 100%;
  line-height: 5px;
  margin-top: 10px;
}
.item-top {
  float: left;
  width: 100%;
  height: 80px;
}

.pay-vip-item > p:nth-child(5) {
  margin-left: 10px;
  float: left;
  font-size: 12px;
  color: #999999;
  margin-top: 15px;
}

.pay-vip-item > label {
  font-size: 22px;
  color: #333333;
}

.pay-vip-item > p {
  font-size: 12px;
  color: #999999;
}

/* 支付方式 */
.pay-vip-list {
  float: left;
  width: 132px;
  height: 196px;
}
.pay-method {
  float: left;
  width: 132px;
  height: 98px;
  text-align: left;
  color: #031710;
  background: #efefef;
  font-size: 14px;
}

.pay-method-active-wx {
  background: #ffffff;
  color: #5BBE6B;
}
.pay-method-active-zfb {
  background: #ffffff;
  color: #52ACEF;
}

.pay-method img {
  float: left;
  margin-right: 9px;
  margin-top: 30px;
  margin-left: 23px;
  width: 36px;
  height: 36px;
}

.pay-method span {
  float: left;
  margin-top: 38px;
}

/* 右侧支付二维码 */
.left-pays {
  float: left;
  width: 114px;
  margin-right: 30px;
  cursor: pointer;
}

.right-qrcode {
  width: 530px;
  float: left;
  height: 100%;
}

.qrcode-box {
  float: left;
  width: 164px;
  height: 164px;
  background: #ffffff;
  margin: 16px 0px 16px 20px;
  border: 1px solid #eeeeee;
}

.qrcode-box div {
  margin: 8px;
  width: 148px;
  height: 148px;
  background: #ffffff;
}

.qrcode-box p {
  font-size: 14px;
  color: #ff5946 !important;
  overflow: hidden;
  position: relative;
  width: 128px;
  top: 50px;
  right: 35px;
}

.right-qrcode p {
  float: left;
  width: 250px;
  text-align: left;
  margin-top: 10px;
  margin-left: 54px;
  font-size: 14px;
  color: #7d8380;
}

.right-qrcode > p:nth-child(2) {
  margin-top: 30px;
}

.right-qrcode > p:nth-child(2) span {
  font-size: 30px;
  font-weight: 600;
  color: #000000;
}

.right-qrcode > p:nth-child(3) span {
  font-size: 16px;
  font-weight: 600;
  color: #ff5946;
}

.right-qrcode > p:nth-child(5) span {
  font-size: 14px;
  color: #30a263;
  text-decoration: underline;
  cursor: pointer;
}

/* 支付成功 begin */
.pay_succ_box {
  height: 304px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}

.pay_succ_box img {
  width: 175px;
  height: 169px;
}

.pay_succ_box span {
  font-weight: bold;
  font-size: 18px;
}

.pay_succ_box p {
  font-size: 14px;
  color: #666666;
  opacity: 0.9;
}

.payerror {
  margin-left: 0px !important;
  right: 0px !important;
  width: 166px !important;
  text-align: center !important;
  max-height: 99px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
}

.upload_sub_btn {
  float: left;
  margin-top: 33px;
  margin-left: 51px;
  width: 146px;
  height: 40px;
  background: #30a263;
  font-size: 14px;
  color: #ffffff;
}
/* 支付成功 end */

/* 商品类型 */
.goods-type {
  /* border: 1px solid; */
  float: left;
  width: 180px;
  height: 100%;
  cursor: pointer;
}
.goods-type-active {
  background: #ffffff;
}
.goods-type p {
  font-size: 22px;
  margin-top: 40px;
}
.goods-type span {
  color: #ff7900;
  padding-top: 10px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/PayVipPopup.vue